// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { localize } from 'i18n-calypso'

class Editable extends React.Component {
	constructor( props ) {
		super( props );

		this.state = {
			isClicked: false
		};
	}

	static defaultProps = {
		element: 'div',
		className: '',
		content: '',
		json: '',
		cap: 'edit_pages'
	}

	handleClick = () => {
		this.setState( {
			isClicked: true
		} )
	}

	renderNonEditable = () => {
		const { className, element, content } = this.props
		const Tag = `${element}`

		const maybeInnerHTML = content ? {
			'dangerouslySetInnerHTML': { __html: content }
		} : {}

		return (
			<Tag
				className={ className }
				{ ...maybeInnerHTML }
			>
				{ this.props.children }
			</Tag>
		)
	}

	render() {
		const { isClicked } = this.state
		const isClickedClass = isClicked ? ' is-clicked' : ''
		const {
			translate,
			id,
			element,
			className,
			content,
			formId,
			linkUrl,
			linkText,
			cap,
			allMetaData,
			allSectionsData,
			userCanEditPage,
			pageId,
			pageSlug,
			sectionId,
			sectionType,
			sectionDataId,
			menuItems,
			menuId
		} = this.props

		// Return early:
		if ( ! userCanEditPage || ! allMetaData ) {
			return this.renderNonEditable()
		}

		// Get data:
		const Tag = `${element}`
		var userCanEditContent = false,
			parentId = this.props.parentId,
			parentSlug = this.props.parentSlug,
			parentTitle = this.props.parentTitle,
			isDelete = this.props.isDelete,
		    parentType,
		    saveLocation,
		    taxonomy,
		    contentType,
		    isSection = '0',
		    isInline,
		    isPlain,
		    isMenu,
		    isFeaturedImage,
		    isImage,
		    isVideo,
		    isImageVideo,
		    isLink,
		    isForm,
		    isMap,
		    isCustom,
		    isSiteSetting,
		    siteSettingTab,
		    message,
		    contentProp,
		    metaId,
		    meta,
		    section

		if ( ! parentId ) {
			parentId = pageId
		}

		if ( ! parentSlug ) {
			parentSlug = pageSlug
		}

		if ( sectionId ) {
			isSection = '1'
		}

		if ( isDelete ) {
			isDelete = '1'
			userCanEditContent = true
		}

		if ( '1' == isSection ) {
			section = allSectionsData[ sectionType ]

			if ( section ) {
				userCanEditContent = section.user_can_edit ? section.user_can_edit : false
				parentType = section.parent_type
				contentProp = content

				if ( section.data[ sectionDataId ] ) {
					contentType = section.data[ sectionDataId ].type
					isInline = 'inline' === contentType ? '1' : '0'
					isPlain = 'text' === contentType ? '1' : '0'
					isImage = 'image' === contentType ? '1' : '0'
					isVideo = 'video' === contentType ? '1' : '0'
					isImageVideo = 'image/video' === contentType ? '1' : '0'
					isLink = 'link' === contentType ? '1' : '0'
					isForm = 'form' === contentType ? '1' : '0'
					isMap = 'map' === contentType ? '1' : '0'
				}
			}
		} else {
			metaId = '_vl_' + id
			meta = allMetaData[ metaId ]

			if ( meta ) {
				userCanEditContent = meta.user_can_edit ? meta.user_can_edit : false
				parentType = meta.parent_type
				saveLocation = meta.save_location
				taxonomy = meta.taxonomy
				contentType = meta.type
				siteSettingTab = meta.site_setting_tab ? meta.site_setting_tab : false
				isInline = 'inline' === contentType ? '1' : '0'
				isPlain = 'text' === contentType ? '1' : '0'
				isMenu = 'menu' === contentType ? '1' : '0'
				isFeaturedImage = 'featured_image' === contentType ? '1' : '0'
				isImage = 'image' === contentType ? '1' : '0'
				isVideo = 'video' === contentType ? '1' : '0'
				isImageVideo = 'image/video' === contentType ? '1' : '0'
				isLink = 'link' === contentType ? '1' : '0'
				isForm = 'form' === contentType ? '1' : '0'
				isMap = 'map' === contentType ? '1' : '0'
				isCustom = 'custom' === contentType ? '1' : '0'
				isSiteSetting = 'site_setting' === contentType ? '1' : '0'
				contentProp = content
			}
		}

		const maybeInnerHTML = content ? {
			'dangerouslySetInnerHTML': { __html: content }
		} : {}

		// Return early:
		if ( ! userCanEditContent ) {
			return this.renderNonEditable()
		}

		// Add extra classes/messages:
		let fullClassName = className + isClickedClass

		if ( 'menu' === contentType ) {
			fullClassName += ' is-editable-menu'
			message = translate( 'Click to edit menu' )
		} else if ( 'form' === contentType ) {
			fullClassName += ' is-editable-form'
			message = translate( 'Click to change' )
		} else if ( 'featured_image' === contentType ) {
			fullClassName += ' is-editable-featured-image'
			message = translate( 'Click to change' )
		} else if ( 'image' === contentType ) {
			fullClassName += ' is-editable-image'
			message = translate( 'Click to change' )
		} else if ( 'video' === contentType ) {
			fullClassName += ' is-editable-video'
			message = translate( 'Click to change' )
		} else if ( 'image/video' === contentType ) {
			fullClassName += ' is-editable-image'
			message = translate( 'Click to change' )
		} else if ( 'link' === contentType ) {
			fullClassName += ' is-editable-link'
		} else if ( 'map' === contentType ) {
			fullClassName += ' is-editable-map'
			message = translate( 'Click to change' )
		} else if ( 'custom' === contentType ) {
			fullClassName += ' is-editable-custom'
		} else if ( 'site_setting' === contentType ) {
			fullClassName += ' is-editable-site-setting'
		} else if ( isDelete ) {
			fullClassName += ' is-delete'
		} else {
			fullClassName += ' is-editable'
		}

		if ( this.props.message ) {
			message = this.props.message
		}

		// Return editable component:
		return (
			<Tag
				className={ fullClassName }
				{ ...maybeInnerHTML }
				// data-id={ id }
				data-parent-type={ parentType }
				data-parent-id={ parentId }
				data-parent-slug={ parentSlug }
				data-parent-title={ parentTitle }
				data-save-location={ saveLocation }
				data-taxonomy={ taxonomy }
				data-content-id={ id }
				data-is-section={ isSection }
				data-section-id={ sectionId }
				data-section-data-id={ sectionDataId }
				data-content={ contentProp }
				// data-parent-post-type={ parentPostType }
				data-is-inline={ isInline }
				data-is-plain={ isPlain }
				data-is-menu={ isMenu }
				data-is-featured-image={ isFeaturedImage }
				data-is-image={ isImage }
				data-is-video={ isVideo }
				data-is-image-video={ isImageVideo }
				data-is-link={ isLink }
				data-is-form={ isForm }
				data-is-map={ isMap }
				data-is-custom={ isCustom }
				data-is-site-setting={ isSiteSetting }
				data-is-delete={ isDelete }
				{ ...( '1' == isMenu && { 'data-is-menu': isMenu } ) }
				{ ...( menuId && { 'data-menu-id': menuId } ) }
				{ ...( menuItems && { 'data-menu-items': menuItems } ) }
				{ ...( '1' == isLink && { 'data-link-url': linkUrl } ) }
				{ ...( '1' == isLink && { 'data-link-text': linkText } ) }
				{ ...( '1' == isForm && { 'data-form-id': formId } ) }
				{ ...( '1' == isSiteSetting && { 'data-site-setting-tab': siteSettingTab } ) }
				data-message={ message }
				onClick={ this.handleClick }
			>
				{ this.props.children }
			</Tag>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	let isArchive = state.page.selectedArchive ? true : false,
		selected = state.page.selectedArchive ? state.page.selectedArchive : state.page.selected,
		// userCanEditPage = selected && selected.user_can_edit ? selected.user_can_edit : false,
		userCanEditPage = siteData.current_user_can_edit_pages,
		pageId = selected && selected.id ? selected.id : false,
		pageSlug = selected && selected.slug ? selected.slug : false

	if ( selected && selected.is_external ) {
		userCanEditPage = false
	}

	return {
		allMetaData: state.content.metaData,
		allSectionsData: state.content.sectionData,
		userCanEditPage,
		pageId,
		pageSlug
	}
}

export default localize(
	connect( mapStateToProps )( Editable )
)